const BUCKETS = new Set(['charleroi', 'wallonia', 'belgium']);
const STORAGE_KEY = 'krol-origin-v1';
const TTL = 15 * 60 * 1000;
let pendingLocation;

const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();

export function classifyLocation(data) {
  if (!data || data.success !== true || String(data.country_code || '').toUpperCase() !== 'BE') return 'belgium';
  const city = normalize(data.city);
  const region = normalize(data.region);
  const code = String(data.region_code || '').toUpperCase().replace(/^BE-/, '');
  if (city === 'charleroi') return 'charleroi';
  const walloonCodes = new Set(['WAL', 'WBR', 'WHT', 'WLG', 'WLX', 'WNA']);
  const walloonNames = new Set(['wallonia', 'wallonie', 'wallonie region', 'walloon region', 'region wallonne', 'wallonie gewest', 'waals gewest', 'hainaut', 'henegouwen', 'liege', 'luik', 'namur', 'namen', 'luxembourg', 'luxemburg', 'walloon brabant', 'brabant wallon', 'waals brabant', 'waals-brabant']);
  return walloonCodes.has(code) || walloonNames.has(region) ? 'wallonia' : 'belgium';
}

function readCache(storage) {
  try {
    const cached = JSON.parse(storage.getItem(STORAGE_KEY));
    if (cached && BUCKETS.has(cached.bucket) && Number.isFinite(cached.expires) && cached.expires > Date.now() && cached.expires <= Date.now() + TTL) return cached.bucket;
  } catch {}
  return null;
}

export async function locate({ fetcher = globalThis.fetch, storage = globalThis.sessionStorage, timeout = 2500 } = {}) {
  const cached = readCache(storage);
  if (cached) return cached;
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeout);
  try {
    const response = await fetcher('https://ipwho.is/?fields=success,country_code,region,region_code,city', {
      signal: controller.signal,
      credentials: 'omit',
      referrerPolicy: 'no-referrer',
      redirect: 'error',
      cache: 'no-store'
    });
    if (!response.ok) return 'belgium';
    const data = await response.json();
    if (data.success !== true) return 'belgium';
    const bucket = classifyLocation(data);
    try { storage.setItem(STORAGE_KEY, JSON.stringify({ bucket, expires: Date.now() + TTL })); } catch {}
    return bucket;
  } catch {
    return 'belgium';
  } finally {
    clearTimeout(timer);
  }
}

export async function updateBanner(element, resolver) {
  if (!element) return;
  let bucket = 'belgium';
  if (element.dataset.designMode === 'true') {
    if (BUCKETS.has(element.dataset.geoPreview)) bucket = element.dataset.geoPreview;
  } else if (element.dataset.geoEnabled === 'true') {
    bucket = await resolver();
  }
  element.textContent = element.dataset[BUCKETS.has(bucket) ? bucket : 'belgium'] || element.dataset.belgium;
}

if (typeof document !== 'undefined') {
  const resolveOnce = () => pendingLocation || (pendingLocation = locate().catch(() => 'belgium'));
  const initialize = root => root.querySelectorAll('[data-krol-geography]').forEach(element => updateBanner(element, resolveOnce));
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
}
